import CommonButton, { CommonButtonType } from '../CommonButton';
import CustomSvg from '../CustomSvg';
import './index.less';

export interface ICompletedProps {
  title?: string;
  description: string;
  iconTitle?: string;
  buttonType?: CommonButtonType;
  onClose: () => void;
}

export default function Completed({
  title = 'Submitted',
  description = '',
  iconTitle = 'Close',
  buttonType = 'primary',
  onClose,
}: ICompletedProps) {
  return (
    <div className="completed-wrapper portkey-ui-flex-column">
      <div className="completed-content portkey-ui-flex-1 portkey-ui-flex-column-center">
        <CustomSvg type="Activity-status-success" />
        <div className="content-main">{title}</div>
        <div className="content-desc">{description}</div>
      </div>
      <div className="completed-button portkey-ui-flex">
        <CommonButton type={buttonType} onClick={onClose} block>
          {iconTitle}
        </CommonButton>
      </div>
    </div>
  );
}
